import React from "react";
import ImageCard from "./ImageCard";
class SummerCard extends React.PureComponent {
    render() {
        const { title, href, imgSrc } = this.props;
        return (<ImageCard className="summer-card" shouldDisplayGenreStrip={false} src={imgSrc} title={title} titleClassName="summer-card-name" imgClassName="summer-card-image" href={href}/>);
    }
}
export default SummerCard;
